<template>
    <layout title="Import Files">
        <div class="relative p-12 bg-gray-50 border-4 border-dashed flex-col border-gray-200 rounded-lg flex items-center justify-center" @dragover="dragover" @dragleave="dragleave" @drop="drop">
            <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle"
                   class="w-px h-px opacity-0 overflow-hidden absolute" @change="onChange" ref="file" />
            <svg class="w-16 h-16 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3"></path></svg>
            <div class="flex  items-center justify-center">
                <p>Drop files here or</p>
                <label for="assetsFieldHandle" class="ml-1 font-bold underline cursor-pointer text-blue-600">
                    browse
                </label>
            </div>
            <ul class="mt-4 mb-12 flex justify-center w-full flex-wrap" v-if="filelist.length" v-cloak>
                <li class="w-48 shadow-lg text-xs overflow-clip overflow-hidden flex items-center justify-between h-12 mx-2 border border-gray-100 bg-white relative p-2 mb-4" v-for="(file, idx) in filelist">
                    <span class="font-mono">{{ file.name }}</span>
                    <div @click="remove(idx)" class="text-red-400 cursor-pointer absolute bottom-0 top-0 right-0 ml-4 mr-2 flex items-center justify-center">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    </div>
                </li>
            </ul>
            <div  @click="upload()" v-if="!saving && filelist.length" class="rounded-lg absolute bottom-0 bg-blue-600 hover:bg-blue-700 left-0 right-0 p-4 mx-2 mb-2 text-blue-50 text-lg font-semibold text-center cursor-pointer">Upload Files</div>
            <div v-if="saving" class="flex items-center justify-center rounded-lg absolute bottom-0 bg-blue-100 text-blue-600 left-0 right-0 p-4 mx-2 mb-2 font-semibold">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span> Uploading...</span>
            </div>
        </div>

        <import-list :importFiles="importFiles"></import-list>
    </layout>
</template>


<script>
import Layout from '@/Shared/Layout'
import ImportList from '@/Components/Import/ImportList'

export default {
    components: {
        Layout,
        ImportList,
    },
    metaInfo() {
        return {
            title: `Upload Files`,
        }
    },
    data() {
        return {
            filelist: [],
            saving: false,
        }
    },
    props: {
        importFiles: Array,
    },
    methods: {
        checkFiles() {
            const acceptedFiles = [
                'cmwebl',
                'cntcact1',
                'cntlb1',
                'csgavgwl',
                'cstkweb1',
                'invwebf',
                'larmweb',
                'csb customer aging export.xlsx',
                'otdetlb1',
                'lbk gin balance.csv',
                'lbk gin annual daily activity.csv',
                'csbitm1.xlsx'
            ];

            this.filelist.forEach((file, idx) => {
                if (! acceptedFiles.includes(file.name.toLowerCase())) {
                    this.remove(idx);
                }
            })
        },
        onChange() {
            this.filelist = [...this.$refs.file.files];
            this.checkFiles();
        },
        remove(i) {
            this.filelist.splice(i, 1);
        },
        dragover(event) {
            event.preventDefault();
            this.showHighlight(event);
        },
        dragleave(event) {
            this.removeHighlight(event);
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange();
            this.removeHighlight(event);
        },
        removeHighlight(event) {
            event.currentTarget.classList.add('bg-gray-50');
            event.currentTarget.classList.remove('bg-green-200', 'border-green-300');
        },
        showHighlight(event) {
            event.currentTarget.classList.remove('bg-gray-50');
            event.currentTarget.classList.add('bg-green-200', 'border-green-300');
        },
        upload() {
            let data = new FormData()
            this.filelist.forEach(file => data.append(`importFiles[]`, file))
            this.$inertia.post(this.route('import.store'), data,
                {
                    onStart: () => this.saving = true,
                    onFinish: () => this.saving = false,
                    onSuccess: () => this.filelist = []
                }
            )
        }
    }
}
</script>
